import React, { Component } from 'react'
import MetaTags from 'components/MetaTags'

import { STORE_LOCATOR_OPTIONS } from 'utils/constants'
import Layout from 'layouts/Layout'
import StoreLocatorContainer from 'components/StoreLocatorContainer'

export default class StoreLocatorPage extends Component {
  state = {
    StoreLocator: null
  }

  async componentDidMount() {
    const StoreLocatorComponent = await import('store-locator')
    this.setState({ StoreLocator: StoreLocatorComponent.default })
  }

  render() {
    const { StoreLocator } = this.state

    return (
      <Layout hideFooter>
        <MetaTags
          title="Find a Vape Pen & E-Cigarette Retailor 📍 | By Vuse"
          description="Find a Vuse e-cirgarette store near you across Canada 🍁. We sell on our online shop and also at retailers, use our map to find the closest for you 📍! Previously govype.ca"
        />
        {StoreLocator && (
          <StoreLocatorContainer>
            <StoreLocator options={STORE_LOCATOR_OPTIONS} />
          </StoreLocatorContainer>
        )}
      </Layout>
    )
  }
}
